import { ReactNode, VFC } from 'react'
import { _menuicon, _profilegreen } from 'src/styles/colors'
import styled from 'styled-components'

const TAB_TYPES = ['FeedbackTab', 'Profile', 'Memo'] as const
const TAB_ROOM_INFO: TabType[] = ['Profile', 'Memo']
export type TabType = typeof TAB_TYPES[number]
export const DEFAULT_TAB_TYPE: TabType = 'Profile'
const TABS: { [key in TabType]: string } = {
  FeedbackTab: 'ユーザーを評価する',
  Profile: 'プロフィール',
  Memo: 'メモ',
}
type TabListProps = {
  activeTab: TabType
  setTabType: (type: TabType) => void
}
export const TabList: VFC<TabListProps> = ({ activeTab, setTabType }) => {
  return (
    <Tabs>
      {/* NOTE: FeedbackTab 選択時は FeedbackTab のみ表示し FeedbackTab 以外はルーム情報を表示する */}
      {activeTab === 'FeedbackTab' ? (
        <TabItem
          key={activeTab}
          open={() => setTabType(activeTab)}
          active={true}
        >
          {TABS.FeedbackTab}
        </TabItem>
      ) : (
        <>
          {TAB_ROOM_INFO.map((tab) => (
            <TabItem
              key={tab}
              open={() => setTabType(tab)}
              active={activeTab === tab}
            >
              {TABS[tab]}
            </TabItem>
          ))}
        </>
      )}
    </Tabs>
  )
}

type TabItemProps = {
  open: VoidFunction
  active: boolean
  children: ReactNode
}

const TabItem: VFC<TabItemProps> = ({ open, active, children }) => {
  return (
    <Tab>
      <TabArea active={active}>
        <TabText onClick={open} active={active}>
          {children}
        </TabText>
      </TabArea>
    </Tab>
  )
}

const Tabs = styled.ul`
  display: flex;
  flex-direction: row;
  width: 100%;
  text-align: center;
`
const Tab = styled.li`
  flex: auto;
`
const TabArea = styled.div<{ active: boolean }>`
  display: flex;
  flex-direction: column;
  border-bottom: 2px solid
    ${({ active }) => (active ? _profilegreen : _menuicon)};
`
const TabText = styled.a<{ active: boolean }>`
  color: ${({ active }) => (active ? _profilegreen : _menuicon)};
  font-weight: ${({ active }) => (active ? 'bold' : 'normal')};
  font-size: 12px;
  padding-top: 32px;
  padding-bottom: 26px;
`
